import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MenuService } from '../services/menu.service';
import { UnitService } from '../services/unit.service';
import { UnitRouteLoadingService } from '../services/unit-route-loading.service';

export const unitResolver: ResolveFn<void> = async (route) => {
  const unitService = inject(UnitService);
  const menuService = inject(MenuService);
  const unitRouteLoading = inject(UnitRouteLoadingService);
  const routeName = route.paramMap.get('routeName');

  if (!routeName) return;

  unitRouteLoading.begin();
  try {
    await unitService.loadUnitInfo(routeName);
  } finally {
    unitRouteLoading.end();
  }

  void menuService.preloadPickupDeliveryAvailabilityForRoute(routeName);
};
